export default defineAppConfig({
  umami: {
    // ...umami config here
  },
  shadcnDocs: {
    site: {
      name: 'Quercy Énergies',
      description: 'Quercy Energies est l’Agence Locale de l’Energie et du Climat du Lot, qui œuvre à répondre aux enjeux de la transition énergétique.',
      ogImage: '/hero.png',
      ogImageComponent: 'ShadcnDocs',
      ogImageColor: 'dark',
      umami: {
        enable: false,
        src: '',
        dataWebsiteId: '',
      },
    },
    theme: {
      customizable: false,
      color: 'orange',
      radius: 0.5,
    },
    banner: {
      enable: false,
      showClose: true,
      content: 'Awesome banner 🚀',
      to: '/',
      target: '_blank',
      border: false,
    },
    header: {
      title: 'Quercy Énergies',
      showTitle: false,
      logo: {
        light: '/logos/logoQE_RVB.svg',
        dark: '/logos/logoQE_RVB-dark.svg',
      },
      darkModeToggle: true,
      class: 'shadow-md',
      height: '5.5rem',
    },
    aside: {
      useLevel: false,
      collapse: false,
      collapseLevel: 1,
      folderStyle: 'group', // default, tree, group
    },
    main: {
      breadCrumb: {
        homeIcon: 'i-lucide-house',
        showIcon: true,
      },
      showTitle: true,
      codeCopyToast: true,
      padded: true,
      editLink: {
        enable: false,
        pattern: 'https://github.com/unpress/nuxt-base/edit/main/content/:path',
        text: 'Edit this page',
        icon: 'lucide:square-pen',
        placement: ['docsFooter', 'toc'],
      },
      codeIcon: {
        'package.json': 'vscode-icons:file-type-node',
        'tsconfig.json': 'vscode-icons:file-type-tsconfig',
        '.npmrc': 'vscode-icons:file-type-npm',
        '.editorconfig': 'vscode-icons:file-type-editorconfig',
        '.eslintrc': 'vscode-icons:file-type-eslint',
        '.eslintrc.cjs': 'vscode-icons:file-type-eslint',
        '.eslintignore': 'vscode-icons:file-type-eslint',
        'eslint.config.js': 'vscode-icons:file-type-eslint',
        'eslint.config.mjs': 'vscode-icons:file-type-eslint',
        'eslint.config.cjs': 'vscode-icons:file-type-eslint',
        '.gitignore': 'vscode-icons:file-type-git',
        'yarn.lock': 'vscode-icons:file-type-yarn',
        '.env': 'vscode-icons:file-type-dotenv',
        '.env.example': 'vscode-icons:file-type-dotenv',
        '.vscode/settings.json': 'vscode-icons:file-type-vscode',
        'nuxt': 'vscode-icons:file-type-nuxt',
        '.nuxtrc': 'vscode-icons:file-type-nuxt',
        '.nuxtignore': 'vscode-icons:file-type-nuxt',
        'nuxt.config.js': 'vscode-icons:file-type-nuxt',
        'nuxt.config.ts': 'vscode-icons:file-type-nuxt',
        'nuxt.schema.ts': 'vscode-icons:file-type-nuxt',
        'tailwind.config.js': 'vscode-icons:file-type-tailwind',
        'tailwind.config.ts': 'vscode-icons:file-type-tailwind',
        'vue': 'vscode-icons:file-type-vue',
        'ts': 'vscode-icons:file-type-typescript',
        'tsx': 'vscode-icons:file-type-typescript',
        'mjs': 'vscode-icons:file-type-js',
        'cjs': 'vscode-icons:file-type-js',
        'js': 'vscode-icons:file-type-js',
        'jsx': 'vscode-icons:file-type-js',
        'md': 'vscode-icons:file-type-markdown',
        'mdc': 'vscode-icons:file-type-markdown',
        'py': 'vscode-icons:file-type-python',
        'npm': 'vscode-icons:file-type-npm',
        'pnpm': 'vscode-icons:file-type-pnpm',
        'npx': 'vscode-icons:file-type-npm',
        'yarn': 'vscode-icons:file-type-yarn',
        'bun': 'vscode-icons:file-type-bun',
        'yml': 'vscode-icons:file-type-yaml',
        'json': 'vscode-icons:file-type-json',
        'terminal': 'lucide:terminal',
      },
    },
    footer: {
      credits: 'Made with ❤️ by [**Emmanuel Salomon**](https://github.com/ManUtopiK)',
      links: [
        {
          title: 'shadcn-vue',
          to: 'https://www.shadcn-vue.com/',
          target: '_blank',
        },
        {
          icon: 'lucide:github',
          to: 'https://github.com/unpress/nuxt-base',
          target: '_blank',
        },
      ],
    },
    toc: {
      enable: true,
      title: 'Sur cette page',
      links: [],
      // links: [{
      //   title: 'Star on GitHub',
      //   icon: 'lucide:star',
      //   to: 'https://github.com/unpress/nuxt-base',
      //   target: '_blank',
      //   showLinkIcon: true,
      // }, {
      //   title: 'Create Issues',
      //   icon: 'lucide:circle-dot',
      //   to: 'https://github.com/unpress/nuxt-base/issues',
      //   target: '_blank',
      //   showLinkIcon: true,
      // }],
    },
    search: {
      enable: true,
      style: 'button',
      inAside: false,
      placeholder: 'Chercher...',
      placeholderDetailed: 'Chercher sur le site...',
    },
  },
})
